define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var server = require('server');
    var config = require('config');
    var user = require('user');

    module.exports = {
        notify: function(notificationData) {
            var id = notificationData.ID;

            id in this && this[id](notificationData.data);
        },

        removeEmailToken: () => {
            var url = new URL(window.location);
            window.Playtech.API.common.replace(url.pathname, undefined, { removeParams: ['emailToken'] });
        },

        afterRegisterEmailVerification: function(data) {
            var status = 'errorCode' in data.resp ? 'error' : 'success';

            window.Playtech.API.popup.showPopup({
                content: i18n.translate('playtech.mobile.system.emailVerification.message.' + status),
                onClose: this.removeEmailToken,
                layer: 'HIGH_PRIORITY'
            });
        },

        emailVerificationStatus: function(data) {
            var details = user.get('userDetails') || {};

            // markEmailVerified - requestedPlayerData 115
            if (user.isLoggedIn() && Number(details.markEmailVerified)) {
                return;
            }

            server.send({
                ID: 35556,
                description: 'Check User Email Verification Status',
                responses: [35557, 35558],
                token: data.token,
                casinoName: config.get('casinoName')
            }).always(this.emailVerificationStatusResp.bind(this));
        },

        emailVerificationStatusResp: function(resp) {
            var data = resp.data;
            var isError = 'errorCode' in data;
            var trKey = 'playtech.mobile.system.emailVerification.status.';
            var description = isError ? 'error.' + data.errorCode : 'success';

            window.Playtech.API.popup.showPopup({
                title: i18n.translate(trKey + 'title.' + (isError ? 'error' : 'success')),
                content: i18n.translate(trKey + description),
                layer: 'HIGH_PRIORITY',
                onClose: this.removeEmailToken
            });
        }
    };
});
